import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { latLng, LatLng, tileLayer, marker, icon} from 'leaflet';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
})
export class ContactComponent {
  export: boolean;
  mess: any = {
    email: '',
    subject: '',
    message: '',
  };

  msgs: any = [];

  contacts: any = [];

  options = {
    layers: [
      tileLayer(
        'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        {
          maxZoom: 18,
          attribution:
            '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        }
      ),
      marker([45.6920242, 3.170288], {
        icon: icon({
          iconSize: [24, 41],
          iconUrl: '/assets/marker-icon-blue.png',
        }),
      }),
    ],
    zoom: 6,
    center: latLng(45.6920242, 3.170288),
  };

  constructor(public api: ApiService) {
    this.api
      .post('SPDO=select', {
        database: 'contact',
        where: 'export = ' + this.api.export,
      })
      .then((res: any) => {
        for (let contact of res['data']) {
          this.contacts.push({
            label: contact.name_contact,
            value: contact.email,
          });
        }
        this.mess.for = this.contacts[0].value;
        if (this.api.export) {
          this.options.center = latLng(50.85561291474791, 4.359520200860481);
          this.options.layers = [
            tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
              maxZoom: 18,
            }),
            marker([50.85561291474791, 4.359520200860481], {
              icon: icon({
                iconSize: [24, 41],
                iconUrl: '/assets/marker-icon-blue.png',
              }),
            }),
          ];
        }
      });
  }

  send() {
    //this.mess.test = true;
    this.api.post('site=sendMail', this.mess).then((res: any) => {
      if (res.statut == 'success') {
        this.api.success('Votre message a bien été envoyé');
        this.mess = {
          email: '',
          subject: '',
          message: '',
        };
      } else {
        this.api.error("Votre message n'a pas pu être transmis.");
      }
    });
  }
}
